import { Navigate, useLocation } from "react-router-dom";
import { PageEndpointEnum } from "../../enums/endpoints";

export function LegacyStakeRedirect() {
  const { search, hash } = useLocation();

  return (
    <Navigate
      to={{ pathname: PageEndpointEnum.REWARDS, search, hash }}
      replace
    />
  );
}
